module.exports = __webpack_public_path__ + "img/bus-station-start.d502cfba.svg";